export interface CommandConfigProcessBinding {
  sectionName: string;
  labelKey: string;
  processKeys: string[];
}

/** Allowlist from ORCHESTRATION.md §6.6.1. Command class names in consumers[] are not process keys. */
export const COMMAND_CONFIG_PROCESSES: CommandConfigProcessBinding[] = [
  {
    sectionName: 'IndexPipelineSettings',
    labelKey: 'Index pipeline',
    processKeys: ['satellite.calculate-index-layers', 'satellite.calculate-season-indices'],
  },
  {
    sectionName: 'SeasonIndicesBackfillSettings',
    labelKey: 'Season-indices backfill window',
    processKeys: ['satellite.backfill-season-indices'],
  },
  {
    sectionName: 'GeoServerOptions',
    labelKey: 'GeoServer',
    processKeys: ['satellite.calculate-index-layers'],
  },
  {
    sectionName: 'RecurringAnomalyDetectionSettings',
    labelKey: 'Recurring anomaly detection',
    processKeys: ['indices.detect-recurring-anomalies'],
  },
  {
    sectionName: 'Jobs:CountryRgbLayers',
    labelKey: 'Country RGB layers',
    processKeys: [
      'satellite.country-rgb-layers',
      'satellite.country-rgb-mosaic',
      'satellite.refresh-copernicus-metadata',
      'satellite.index-tiff-ingest',
      'satellite.index-tile-map-backfill',
    ],
  },
  {
    sectionName: 'CropAgro',
    labelKey: 'CropAgro',
    processKeys: ['crop.load-crop-agro-initial', 'crop.apply-crop-agro-lands'],
  },
  {
    sectionName: 'PlantDiagWeather',
    labelKey: 'Plant Diag Weather',
    processKeys: ['analitic.collect-plant-diag-results', 'analitic.generate-farmer-reports'],
  },
  {
    sectionName: 'FarmerReport',
    labelKey: 'Farmer reports',
    processKeys: [
      'analitic.generate-farmer-reports',
      'analitic.request-farmer-report-for-finished-bids',
      'analitic.request-farmer-report-for-satellite-anomalies',
    ],
  },
  {
    sectionName: 'Cadastre',
    labelKey: 'Cadastre',
    processKeys: ['crop.sync-cadastre-parcels'],
  },
  {
    sectionName: 'YieldForecastTransfer',
    labelKey: 'Yield forecast transfer',
    processKeys: ['ai.transfer-yield-forecast-to-seasons'],
  },
  {
    sectionName: 'Qwen',
    labelKey: 'Qwen',
    processKeys: [
      'analitic.submit-bids-to-qwen',
      'analitic.fetch-qwen-results',
      'analitic.collect-qwen-full-analysis',
      'analitic.start-qwen-analysis',
    ],
  },
];

export function processKeysForSection(sectionName: string | null | undefined): string[] {
  return COMMAND_CONFIG_PROCESSES.find(item => item.sectionName === sectionName)?.processKeys ?? [];
}

export function configsForProcess(processKey: string | null | undefined): CommandConfigProcessBinding[] {
  if (!processKey) {
    return [];
  }
  return COMMAND_CONFIG_PROCESSES.filter(item => item.processKeys.includes(processKey));
}
